module.exports = __webpack_public_path__ + "static/media/sergey-cat-2.b5a37213.jpg";